import styled from "@emotion/styled";

export const StyledTimePicker = styled.div`
  margin-bottom: 24px;
`;
